<!--物流详情-->
<template>
    <div>
        <van-cell-group>
            <van-cell :title="express.company_name" label="物流跟踪">
                {{express.num}}
                <span style="color: #0076FF;">
                    <button type="button" class="btn"
                            v-clipboard:copy="express.num"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                                复制
                            </button>
                </span>
            </van-cell>
        </van-cell-group>

        <div class="express-trace-detail">
            <div>
                <div v-for="(item, index) in list">
                    <div class="time-item">
                        <div>
                            {{item.title}}
                        </div>
                        <div class="time">
                            {{item.create_time_format}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<style scoped>
    .express-trace-detail{
        padding: 30px 30px
    }

    .time-item{
        background: #efefef;
        border-radius: 10px;
        padding:10px
    }

    .time-item .time{
        color: #999;
    }


    .row-right-tip{
        color: #0076FF;
    }

</style>

<script>
    import { Cell, CellGroup,Toast   } from 'vant';

    export default {
        components: {
            Cell,
            CellGroup,
            Toast
        },
        data: function () {
            return {
                express: {},
                list: []
            }
        },
        filter: {},
        mounted() {
            document.title='快递跟踪';
            this.getExpressDetail()
        },
        destroyed() {

        },
        methods: {
            // 获取运费详情
            getExpressDetail() {
                let that = this;
                let id = this.$route.query.id;
                // console.log(id)

                this.$api.get('/api/order/expressTrace', {'express_id': id}, (res)=> {
                    that.express = res.data.data;
                    that.list = res.data.list;
                    // console.log(res)
                })
            },

            // 复制订单号
            onCopy(e) {
                Toast.success('复制成功');
            },
            onError(e) {
                console.log('复制失败！');
            },

        }
    }
</script>



// WEBPACK FOOTER //
// ExpressTrace.vue?2b68c2c1